// extracted by mini-css-extract-plugin
export default {"unpausebutton":"pause_unpausebutton__OIEZf","pausetext":"pause_pausetext__VgcMM","logo":"pause_logo__g9rR8","alldetails":"pause_alldetails__88etb"};